<template>
  <div data-testid="page-order-item-lister">
    <!-- title -->
    <div class="flex h-10 cursor-pointer items-center justify-between" @click="isOpen = !isOpen">
      <h2 class="txt-headline-m">{{ category?.name ?? 'Uncategorized' }}</h2>
      <SvgIcon :path="isOpen ? mdiChevronUp : mdiChevronDown" :size="24" class="mr-2" />
    </div>
    <template v-if="isOpen">
      <!-- delivery time display -->
      <div v-if="category?.enableDeliveryTimeslots" class="mb-4 flex flex-wrap gap-2">
        <p>
          {{ $t('FestivalShop.orders.manage.delivery_time') }}
          {{
            category?.kioskSelectedDeliverySlot
              ? formatDeliverySlot(category?.kioskSelectedDeliverySlot, locale as LocaleEnum)
              : category?.secondDayDeliveryDefault
                ? $t('FestivalShop.products.details.configure.delivery_time.second_day_overnight_key')
                : $t('FestivalShop.products.details.configure.delivery_time.overnight_key')
          }}
        </p>
        <button
          v-if="category.deliverySlots.length || category.kioskSelectedDeliverySlot"
          class="btn-link-neutral-s-underline"
          @click="handleDeliveryTimeChange"
        >
          {{ $t('FestivalShop.orders.manage.delivery_time_change') }}
        </button>
      </div>
      <!-- content -->
      <div class="mt-4 flex flex-col gap-4">
        <OrderItem
          v-for="item in items"
          :key="item.displayId"
          :item="item"
          :order-id="orderId"
          :event-slug="eventSlug"
          :kiosk-id="kioskId"
        />
      </div>
    </template>
  </div>
</template>
<script lang="ts" setup>
import { mdiChevronDown, mdiChevronUp } from '@mdi/js'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import SvgIcon from '@/components/SvgIcon.vue'
import type { LocaleEnum, ProductCategory } from '@/gql/myomr'

import { formatDeliverySlot, type ExtrasOrderItem } from '..'
import OrderItem from './OrderItem.vue'

const props = defineProps<{
  category: ProductCategory | null
  items: ExtrasOrderItem[]
  orderId: string
  eventSlug: string
  kioskId: string
}>()

const emit = defineEmits<{
  'change-delivery-time': [ProductCategory]
}>()

const { locale } = useI18n()

const isOpen = ref(true)

const handleDeliveryTimeChange = () => {
  if (props.category) {
    emit('change-delivery-time', props.category)
  }
}
</script>
